import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class PublishProductIssueRequest extends BaseUpdateRequest {
    onSale: boolean = true;
}